/**
 * Generador de UUID v4 para client_idempotency_key en envíos de WhatsApp.
 *
 * Cada intento de envío del cliente genera un key único. El backend usa una
 * UNIQUE constraint en `wa_messages(tenant_id, conversation_id, client_idempotency_key)`
 * para deduplicar doble-clicks y retries de red — el segundo INSERT con
 * mismo key retorna el message_id original sin volver a enviar a Evolution.
 *
 * Patrón Stripe-style: "intent ID" generado del lado cliente, server gates.
 *
 * Importar y usar:
 *   import { newIdempotencyKey } from '@/lib/waIdempotency';
 *   await supabase.functions.invoke('whatsapp-send-message', {
 *     body: { ..., client_idempotency_key: newIdempotencyKey() }
 *   });
 */

export function newIdempotencyKey(): string {
  // crypto.randomUUID disponible en navegadores modernos + Deno + Node 14.17+
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback (entornos viejos): UUID v4 manual.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
